import { Component, Element, h } from '@stencil/core';

@Component({
	shadow: true,
	styleUrl: 'zds-form-error.scss',
	tag: 'zds-form-error',
})
export class ZdsFormError {
	@Element() hostElement: HTMLElement;

	render() {
		return (
			<div class="zds-form-error">
				<slot />
			</div>
		);
	}
}
